module.exports = __webpack_public_path__ + "static/img/资源 46.d8dfd4c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/资源 46.png
// module id = NnmX
// module chunks = 1